import { useQuery } from '@tanstack/react-query';
import { getBookingDocuments } from './bookingDocumentsService';
// Service

/**
 * @description Get the list of booking documents.
 * @param {object} params - The query parameters.
 * @param {object} params.queryParams - The query parameters.
 * @param {string} params.bookingId - The booking id.
 * @param {QueriesOptions} [options] useQuery Options
 * @returns {import('@tanstack/react-query').UseQueryResult<
 * {total: number, page: number, data: BookingDocument[]}, Error>}
 */
export const useGetBookingDocumentListQuery = (params, options) => useQuery({
  queryKey: ['get-bookings', params],
  queryFn: () => getBookingDocuments(params),
  ...options,
});
